export type TimeOfDay = 'morning' | 'afternoon' | 'evening';

export const getCurrentTimeOfDay = (): TimeOfDay => {
  const currentHour = new Date().getHours();

  if (currentHour >= 5 && currentHour < 12) {
    return 'morning';
  } else if (currentHour >= 12 && currentHour < 18) {
    return 'afternoon';
  } else {
    return 'evening';
  }
};
export const isActivityTimeValid = (activityTimeOfDay: string): boolean => {
  const currentTimeOfDay = getCurrentTimeOfDay();
  return activityTimeOfDay === currentTimeOfDay;
};
